module.exports = __webpack_public_path__ + "static/media/plus.3ed8f81b.svg";